import { Box, Button, Paper, Stack, Typography, Grid, FormControl, Card, FormHelperText } from "@mui/material";
import { getGridStringOperators } from "@mui/x-data-grid";
import { useEffect, useState, useCallback, useContext } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import NodataImg from "../../assets/images/noData.png";
import { courseDiscussionApi, resetCourseDiscussion } from "../../store/course-discussion/courseDiscussionList"
import { useParams } from "react-router-dom";
import EditIcon from '@mui/icons-material/Edit';
import { ThemeContext } from '../../context/ThemeContext';
import CustomGridToolbar from "../../components/CustomGridToolbar";
import apiRoutes from "../../store/apiConfigs";
import BackdropUI from "../../ui/Backdrop";
import ArrowRightAltIcon from '@mui/icons-material/ArrowRightAlt';
import PublishUnpublishModule from "../../components/PublishUnpublishModuleDiscussion";
import DataGridComponent from "../../components/DataGridComponent";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import dayjs from "dayjs";
import { useForm } from "react-hook-form";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import redFlag from "../../assets/icons/red_flag.png"
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';

import PermissionGate from "../../components/PermissionGate";

export default function CourseDiscussionList({ courseId }) {
  const discussionSelector = useSelector((state) => state?.courseDiscussions);
  const { result, loading, total } = discussionSelector;
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [error, setError] = useState(null);
  const [isDownload, setIsDownload] = useState(false)
  const [selectedRow, setSelectedRow] = useState([]);
  const [publishModel, setPublishModel] = useState(false);
  const { paginationModel, setPaginationModel } = useContext(ThemeContext)
  const [queryOptions, setQueryOptions] = useState({});
  const [startDate, setStartDate] = useState();
  const [endDate, setEndDate] = useState();
  const [notSelectedProductModel, setNotSelectedProductModel] = useState(false);
  const [deleteId, setDeleteId] = useState(null);
  const schema = yup
    .object({})
    .required();
  const schemaEdit = yup
    .object({})
    .required();
  const params = useParams();
  const {
    register,
    handleSubmit,
    control,
    formState: { errors },
    reset,
  } = useForm({
    resolver: yupResolver(params.id ? schemaEdit : schema),
    defaultValues: {},
  });
  const onFilterChange = useCallback((filterModel) => {
    setQueryOptions({ filterModel: { ...filterModel } });
  }, []);
  const columns = [
    {
      field: "id",
      headerName: "Discussion Id",
      filterable: false,
      sortable: false,
      width: 150,
      renderCell: (fieldData) => {

        return (
          <Box sx={{
            display: 'flex',
            justifyContent: 'space-between',
            flex: "auto"
          }}>
            <text>
              {fieldData.value}
            </text>

            {fieldData?.row?.visibility ? null : <img src={redFlag} alt="logo" height={20} width={20} style={{ marginLeft: '35px' }} />}
            <Box></Box>
          </Box >
        )
      }
    },
    {
      field: "content",
      headerName: "Content",
      filterable: true,
      filterOperators: getGridStringOperators().filter(
        (operator) => operator.value === 'equals' | operator.value === 'contains',
      ),
      sortable: false,
      width: 350,
    },
    {
      field: "user_name",
      headerName: "Added By",
      filterable: true,
      filterOperators: getGridStringOperators().filter(
        (operator) => operator.value === 'equals' | operator.value === 'contains',
      ),
      sortable: false,
      width: 350,
    },

    {
      field: "update_discussion_comment",
      headerName: "Update Discussion",
      filterable: false,
      sortable: false,
      width: 150,
      disableExport: true,
      renderCell: (fieldData) => (
        <>
          <PermissionGate module="courses" action="update">
            <Button
              color="info"
              endIcon={<EditIcon />}
              label="Available" variant="outlined"
              onClick={() => navigate(
                `/courses/discussion/${courseId}/edit-discussion-comment/${fieldData.id}`, {
                state: { postData: fieldData.row, courseId }
              }
              )}
            >
              Edit
            </Button>
          </PermissionGate>
        </>
      ),
    },
    {
      field: "publish",
      headerName: "Publish Discussion",
      filterable: false,
      sortable: false,
      width: 200,
      disableExport: true,
      renderCell: (row) => (
        <>
          <PermissionGate module="courses" action={row.row.visibility ? "unpublish" : "publish"}>
            <Button
              color="info"
              label="Available" variant="outlined"
              onClick={() => {
                setPublishModel(true)
                setSelectedRow(row.row)
              }}
              endIcon={<ArrowRightAltIcon />}
            >
              {row.row.visibility ? "Unpublish" : "Publish"}
            </Button>
          </PermissionGate>
        </>
      ),
    },
  ];

  const getDiscussionList = useCallback((queryOptions, paginationModel) => {
    const filterModel = queryOptions?.filterModel;
    const items = filterModel?.items;
    const firstItem = items && items.length > 0 ? items[0] : {};
    const quickFilterValues = filterModel?.quickFilterValues;

    const query = {
      course_id: courseId,
      page: paginationModel?.page + 1,
      page_size: paginationModel?.pageSize,
      field: firstItem.field || '',
      operator: firstItem.operator || (quickFilterValues && "contains") || '',
      value: firstItem.value || (quickFilterValues && quickFilterValues.toString().replaceAll(",", " ")) || '',
      search: firstItem.value || (quickFilterValues && quickFilterValues.toString().replaceAll(",", " ")) || '',
      start_date: startDate,
      end_date: endDate
    };
    dispatch(courseDiscussionApi(query));
  }, [dispatch, startDate, endDate, courseId])

  useEffect(() => {
    getDiscussionList(queryOptions, paginationModel)
    dispatch(resetCourseDiscussion());
  }, [dispatch, queryOptions, paginationModel, getDiscussionList, startDate, endDate]);

  const handleClear = async () => {
    setStartDate()
    setEndDate()
  };
  return (
    <>
      <Stack direction="row" spacing={1} sx={{ my: 2 }} alignItems="center">
        <form id="outer_form_contect_manage_discussion">
          <Grid container spacing={2}>
            <Grid item xs={12} sm={12} md={4} lg={4}>
              <Card>
                <Stack direction="row" spacing={2}>
                  <FormControl variant="outlined" fullWidth>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DatePicker
                        {...register("startTime")}
                        label="From*"
                        name="startTime"
                        id="outlined-adornment-email"
                        onError={(newError) => setError(newError)}
                        maxDateTime={endDate ? dayjs(endDate) : null}
                        placeholder="From"
                        error={errors?.startTime?.message}
                        value={startDate ? dayjs(startDate) : null}
                        onChange={(newValue) => {
                          setStartDate(dayjs(newValue).format("YYYY-MM-DD"));
                        }}
                      />
                    </LocalizationProvider>
                    <FormHelperText error>
                      {errors?.startTime?.message}
                    </FormHelperText>
                  </FormControl>
                </Stack>
              </Card>
            </Grid>
            <Grid item xs={12} sm={12} md={4} lg={4}>
              <Card>
                <Stack direction="row" spacing={2}>
                  <FormControl variant="outlined" fullWidth>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DatePicker
                        {...register("endDate")}
                        label="To*"
                        name="endDate"
                        id="outlined-adornment-email"
                        minDate={startDate ? dayjs(startDate) : null}
                        onError={(newError) => setError(newError)}
                        maxDateTime={endDate ? dayjs(endDate) : null}
                        disableFuture={true}
                        placeholder="To"
                        error={errors?.startTime?.message}
                        value={endDate ? dayjs(endDate) : null}
                        onChange={(newValue) => {
                          setEndDate(dayjs(newValue).format("YYYY-MM-DD"));
                        }}
                      />
                    </LocalizationProvider>
                    <FormHelperText error>
                      {errors?.startTime?.message}
                    </FormHelperText>
                  </FormControl>
                </Stack>
              </Card>
            </Grid>
            <Grid item xs={12} sm={12} md={4} lg={4}>
              <Card>
                <Stack direction="row" spacing={2}>
                  <FormControl variant="outlined" fullWidth>
                    <Button sx={{
                      minHeight: "41px"
                    }} type="button" onClick={() => handleClear()} variant="outlined">Clear</Button>
                  </FormControl>
                </Stack>
              </Card>
            </Grid>
          </Grid>
        </form>
      </Stack>
      <Paper elevation={0}>
        <DataGridComponent
          loading={loading}
          rowCount={total}
          pageSizeOptions={[5, 10, 20, 50, 100]}
          pageSize={paginationModel?.pageSize}
          onPageSizeChange={(newPageSize) => {
            setPaginationModel({
              ...paginationModel,
              pageSize: newPageSize,
            })
          }}
          paginationModel={paginationModel}
          onPaginationModelChange={setPaginationModel}
          pagination
          paginationMode="server"
          sx={{
            height: 500
          }}
          getRowId={(row) => row.id}
          rows={result}
          columns={columns}
          disableColumnSelector
          disableDensitySelector
          filterMode="server"
          onFilterModelChange={onFilterChange}
          slots={{
            noRowsOverlay: () => (
              <Box className="noData">
                <img src={NodataImg} alt="no data found" />
              </Box>
            ),
            toolbar: (props) =>
              (CustomGridToolbar({ ...props, moduleType: "courseDiscussionManagement", queryOptions: queryOptions, paginationModel: paginationModel, isDownload: isDownload,download_csv:isDownload, setIsDownload: setIsDownload, permissionModule: "courses",course_id:courseId, apiUrl: `api/v1/discussion/courses/comments/` })),
          }}
          slotProps={{
            loadingOverlay: {
              variant: 'linear-progress',
              noRowsVariant: 'linear-progress',
            },
            toolbar: {
              showQuickFilter: true,
            },
          }}
        />
      </Paper>
      <PublishUnpublishModule
        open={publishModel}
        setOpen={setPublishModel}
        selectedRow={selectedRow}
        queryOptions={queryOptions}
        paginationModel={paginationModel}
        moduleType={"discussion"}
        moduleList={getDiscussionList}
      />
      <BackdropUI open={isDownload} />
    </>
  );
}
